export const automodesListSelector = (store) => store.automode.automodes;
export const automodesMetaDataSelector = (store) => store.automode.metaData;

export const isLoadingCreateAutomodeSelector = (store) => store.automode.isLoadingCreateAutomode;
export const isLoadingFetchAutomodesSelector = (store) => store.automode.isLoadingFetchAutomodes;
export const isLoadingUpdateAutomodeSelector = (store) => store.automode.isLoadingUpdateAutomode;
export const isLoadingDeleteAutomodeSelector = (store) => store.automode.isLoadingDeleteAutomode;
